import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Panel, Button, Grid, Row, Col, Glyphicon } from 'react-bootstrap';
import SimpleInput from '../components/common/SimpleInput';
import { getApiKeys, createApiKey, deleteApiKey } from '../redux/modules/apiKeys';
import GenericTable from '../components/GenericTable';

const ApiKeyForm = ({ onSubmit }) => {
  const [note, setNote] = useState(null);
  return (
    <Panel bsStyle="primary">
      <Panel.Heading>
        <Panel.Title componentClass="h3">Generate API Keys</Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <form
          className="form-horizontal"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(note);
          }}
        >
          <SimpleInput
            name="note"
            type="text"
            label="Note"
            placeholder="Add a friendly reminder to yourself about the keys purpose"
            onChange={({ target }) => setNote(target.value)}
            value={note}
          />
          <Button className="pull-right" bsStyle="primary" type="submit">
            Generate Key
          </Button>
        </form>
      </Panel.Body>
    </Panel>
  );
};

const ApiKeyHome = ({ apiKeys = [], getApiKeys, createApiKey, deleteApiKey }) => {
  const handleSubmit = async (apiKeyNote) => {
    await createApiKey(apiKeyNote);
  };

  useEffect(() => {
    getApiKeys();
  }, []);

  return (
    <React.Fragment>
      <Helmet title="My API Keys" />
      <Grid>
        <Row style={{ paddingBottom: 16 }}>
          <Col xs={12}>
            <ApiKeyForm onSubmit={handleSubmit} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h4> API KEYS </h4>
            <GenericTable
              headers={['note', 'key', 'created', 'remove']}
              data={apiKeys.map((key) => ({
                ...key,
                remove: (
                  <Glyphicon
                    glyph="remove"
                    style={{ paddingLeft: 8, color: 'red' }}
                    onClick={() => deleteApiKey(key._id)}
                  />
                ),
              }))}
              responsive
              striped
              bordered
              condensed
              hover
            />
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
};

export default connect(({ apiKeys }) => ({ ...apiKeys }), {
  getApiKeys,
  createApiKey,
  deleteApiKey,
})(ApiKeyHome);



// WEBPACK FOOTER //
// ./src/containers/ApiKeys.js